export const regexp = '[\'"{\\]\\[}\\\\€$~!@#$%^&*()_:;–]'
